module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "697px",
      "height": "550px",
      "border": "#ccc solid 1px"
    },
    attrs: {
      "id": "dituContent2"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-306470f4","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map2.vue
// module id = 201
// module chunks = 6 7